import axios from 'axios'

// L'adresse de l'API vient de la variable VUE_APP_API_URL, lue au moment de la compilation
// (à définir sur Render pour le site en ligne). En local, on garde le serveur Rails habituel.
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3006',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

export default apiClient
